import * as dailyQuota from './dailyQuota';
import * as priorizationDates from './priorizationDates';

const reducers = {
  ...dailyQuota,
  ...priorizationDates,
};

export default reducers;
